export default __webpack_public_path__ + "static/media/question.301bb494.png";